import * as Yup from 'yup'
import { useState, useEffect } from 'react'
import { Icon } from '@iconify/react'
import { useFormik, Form, FormikProvider } from 'formik'
import eyeFill from '@iconify/icons-eva/eye-fill'
import eyeOffFill from '@iconify/icons-eva/eye-off-fill'
import { useNavigate } from 'react-router-dom'
// material
import { Stack, TextField, IconButton, InputAdornment, Modal, Backdrop, Fade, Box, Typography, Grid } from '@material-ui/core'
import { LoadingButton } from '@material-ui/lab'
import { useSnackbar } from 'notistack5'

import useUser from 'utils/api/users'
import storage from 'utils/storage';
// ----------------------------------------------------------------------

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function StoreOnboardForm() {
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const [showPassword, setShowPassword] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [role, setRole] = useState()
  const [set_u] = useState({})

  const OnboardSchema = Yup.object().shape({
    firstName: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('First name required'),
    lastName: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Last name required'),
    company: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Company/ Store name required'),
    phone: Yup.string().min(11, 'Not a valid phone number! (ex. 091523468790)').max(11, 'Not a valid phone number! (ex. 091523468790)').required('Phone number is required'),
    email: Yup.string().email('Email must be a valid email address').required('Email is required'),
    password: Yup.string().required('Password is required'),
  })

  useEffect(() => {
    const load = async () => {
      setLoading(true)
      const url = window.location.href;
      const parts = url.split('/');
      const group = parts[parts.length - 2]; // This gets 'group'
      if(group === "group") {
        setRole(3)
      }
      setLoading(false)
    }

    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
      company: '',
      phone: '',
      password: '',
      role: role
    },
    enableReinitialize: true,
    validationSchema: OnboardSchema,
    onSubmit: async (values) => {
      setLoading(true)

      if (
        !values &&
        (!values?.company ||
          !values?.phone ||
          !values?.email ||
          !values?.firstName ||
          !values?.lastName ||
          !values?.password)
      )
        return setLoading(false)

      const result = await useUser.post_store_register(values)
      if (!result.ok) {
        enqueueSnackbar(result.data.msg, { variant: 'error' })
        return setLoading(false)
      }
      await storage.storeUser(result.data);
      await storage.storeToken(result.data.token);
      alert("Your store account request has been submitted successfully! You will receive an email once your account is activated")
      /*enqueueSnackbar('Store registration success', { variant: 'success' })*/
      setLoading(false)
      navigate('/login', { replace: true })
    },
  })

  const { errors, touched, handleSubmit, getFieldProps } = formik
  const handleClose = () => {
    setOpen(false)
  }
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField
              autoFocus
              fullWidth
              label="First name"
              {...getFieldProps('firstName')}
              error={Boolean(touched.firstName && errors.firstName)}
              helperText={touched.firstName && errors.firstName}
            />

            <TextField
              fullWidth
              label="Last name"
              {...getFieldProps('lastName')}
              error={Boolean(touched.lastName && errors.lastName)}
              helperText={touched.lastName && errors.lastName}
            />
          </Stack>

          <TextField
            fullWidth
            label="Company/Store name"
            {...getFieldProps('company')}
            error={Boolean(touched.company && errors.company)}
            helperText={touched.company && errors.company}
          />

          <TextField
            fullWidth
            type="tel"
            inputProps={{ maxLength: 11, minLength: 11 }}
            label="Phone number"
            {...getFieldProps('phone')}
            error={Boolean(touched.phone && errors.phone)}
            helperText={touched.phone && errors.phone}
          />

          <TextField
            fullWidth
            autoComplete="username"
            type="email"
            label="Email address"
            {...getFieldProps('email')}
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email}
          />

          <TextField
            fullWidth
            autoComplete="current-password"
            type={showPassword ? 'text' : 'password'}
            label="Password"
            {...getFieldProps('password')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton edge="end" onClick={() => setShowPassword((prev) => !prev)}>
                    <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            error={Boolean(touched.password && errors.password)}
            helperText={touched.password && errors.password}
          />

          <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isLoading}>
            {role === 3 ? 'Create group account' : 'Create client account'}
          </LoadingButton>
        </Stack>
    </Form>
      
    </FormikProvider>


  )
}
